import Select from '../../../design-system/components/Select';

export default Select;
